import { render } from "./ContactConfirm.vue?vue&type=template&id=3a142485&ts=true"
import script from "./ContactConfirm.vue?vue&type=script&lang=ts"
export * from "./ContactConfirm.vue?vue&type=script&lang=ts"

import "./ContactConfirm.vue?vue&type=style&index=0&id=3a142485&lang=scss"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__